import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  value: '',
  disabled: "",
  selected: ""
}
const _hoisted_3 = { value: 0 }
const _hoisted_4 = ["value"]

import { ref, onMounted } from "vue";
import agent from "@/services/agent";
import { CompanyInfo } from "../features/Company/Company.model";

// State

export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyCommonComponent',
  emits: ["onCompanyChange"],
  setup(__props, { emit: __emit }) {

const data = ref<CompanyInfo[]>([]);

// Emits event
const emit = __emit;

// Load company data when the component is mounted
async function loadCompany() {
  const response = (await agent.get<any>("v1/company")) || {};
  if (response.result) {
    data.value = response.result?.result;
  }
}

onMounted(() => {
  loadCompany();
});

// Handle company change
function changeCompany(event: Event) {
  const selectedCompanyId = (event.target as HTMLSelectElement).value;
  emit("onCompanyChange", selectedCompanyId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      class: "form-control input-sm custom-select",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (changeCompany($event)))
    }, [
      _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.$t('selectCompany')), 1),
      _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t("all")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.id,
          value: item.id
        }, _toDisplayString(item.name), 9, _hoisted_4))
      }), 128))
    ], 32)
  ]))
}
}

})